export const AI_ANSWER_SOURCE = 'ai_answer';

export const INQUIRY_SOURCE_VALUES = [
  AI_ANSWER_SOURCE,
  'search_engine',
  'partner_referral',
  'event',
  'content_social',
  'other',
] as const;

export const AI_SERVICE_VALUES = [
  'chatgpt',
  'gemini',
  'perplexity',
  'claude',
  'microsoft_copilot',
  'other',
  'unknown',
] as const;

export type InquirySource = (typeof INQUIRY_SOURCE_VALUES)[number];
export type AiService = (typeof AI_SERVICE_VALUES)[number];

export function isInquirySource(value: unknown): value is InquirySource {
  return INQUIRY_SOURCE_VALUES.some((source) => source === value);
}

export function isAiService(value: unknown): value is AiService {
  return AI_SERVICE_VALUES.some((service) => service === value);
}
